import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SeoGet } from '../../services';

export const fetchSeoGet = createAsyncThunk(
    'seoGet/fetchSeoGet',
    async ({ id }) => {
        const response = await SeoGet(id)
        return response.result
    }
);

const seoGetSlice = createSlice({
    name: 'seoGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoGetSlice.reducer;
